
import ApiClient from '../apisClient';


const api = new ApiClient();
async function getEnergyCostByCountry(country,currency) {
    const apiUrl = `/api/v1/energy-cost/${country}?currency=${currency}`;
    
    try {
        const response = await api.get(apiUrl); 
        const data = response.cost_of_energy;
        
        // Assuming the API returns an object with a 'cost' property
        const energyCost = data;
        
        console.log(`Energy cost in ${country}: ${energyCost}`);
        return energyCost;
    } catch (error) {
        console.error(`Error fetching energy cost for ${country}:`, error);
        throw error;
    }
}

export default getEnergyCostByCountry;
// Example usage
